module.exports = __webpack_public_path__ + "img/@news_view_bottom.11726a2b.jpg";